import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap';
import Icon from './Icon';
 
const Footer = props => {
  const socialMediaLinks = {
    facebook: 'https://facebook.com/annarbortshirtcompany',
    twitter: 'https://twitter.com/annarbortees',
    instagram: 'https://instagram.com/annarbortees',
    pinterest: 'https://pinterest.com/annarbortees',
  };

  return (
    <footer>
      <div
        className="row footer-break-row"
        style={props.customStyle.footerStyle}>
        <div className="container">
          <Row>
            <Col className="text-center">
              <div>
                <strong> Get social with Ann Arbor Tees </strong>
              </div>
              <a
                href={socialMediaLinks.facebook}
                style={props.customStyle.footerColorTwo}>
                <Icon.FaFacebookIcon />
              </a>
              <a
                href={socialMediaLinks.twitter}
                style={props.customStyle.footerColorTwo}>
                <Icon.FaTwitterIcon />
              </a>
              <a
                href={socialMediaLinks.instagram}
                style={props.customStyle.footerColorTwo}>
                <Icon.FaInstagramIcon />
              </a>
              <a
                href={socialMediaLinks.pinterest}
                style={props.customStyle.footerColorTwo}>
                <Icon.FaPinterestIcon />
              </a>
            </Col>
          </Row>
        </div>
      </div>
      <div className="row footer-row">
        <div className="container text-center">
          <Col>
            <br />
            <h5 style={{color: props.customStyle.footerColor}}>
              {' '}
              The Ann Arbor Tees Story{' '}
            </h5>
            <p style={{color: props.customStyle.footerColor}}>
              The{' '}
              <a href="http://www.annarbortees.com" className="active_link">
                Ann Arbor T-shirt Company
              </a>{' '}
              was founded in 2008 in a two bedroom apartment on the north side
              of Ann Arbor, Michigan. We have since moved all the way across
              town to the south side, where our warehouse designs, prints, and
              ships t-shirts and other apparel all over the world. We have 50 -
              80 employees depending on the time of year, two dogs, and an
              embroidery art specialist who is fairly cat-like. We run
              world-class printing equipment made in Chicago, Illinois to make
              sure our work is as good as it possibly can be, and proudly stand
              by it.
            </p>
          </Col>
        </div>
      </div>
      <Row>
        <Col>
          <p
            className="text-center"
            style={{color: props.customStyle.footerColor}}>
            The Ann Arbor T-shirt Company and Logo is Trademark of the
            <a href="http://www.annarbortees.com" className="active_link">
              The Ann Arbor T-shirt Company
            </a>{' '}
            LLC
            <br />
            All Content is Copyright © 2008-2017
          </p>
        </Col>
      </Row>
    </footer>
  );
};

Footer.propTypes = {
  customStyle: PropTypes.object.isRequired,
};

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js